import { ColumnDetails, ColumnType } from '../../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../../utils/translator.helper';

export enum Column {
  PRIORITY = 1,
  NAME = 2,
  IP = 3,
  CUSTOM_HOST_NAME = 4,
}
export enum ColumnKeys {
  PRIORITY = 'defaultPositionInGrid',
  NAME = 'name',
  IP = 'ip',
  CUSTOM_HOST_NAME = 'customHostname',
}

export const GRID_COLUMNS = [Column.PRIORITY, Column.NAME, Column.IP, Column.CUSTOM_HOST_NAME];
export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.NAME, ColumnKeys.IP, ColumnKeys.CUSTOM_HOST_NAME];
export const FILTERS = [
  { [ColumnKeys.NAME]: { contains: '' } },
  { [ColumnKeys.IP]: { contains: '' } },
  { [ColumnKeys.CUSTOM_HOST_NAME]: { contains: '' } },
];

export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.PRIORITY,
      key: ColumnKeys.PRIORITY,
      columnName: translateFn('Priority'),
      type: ColumnType.NUMBER,
      filteringDisabled: true,
      removable: false,
    },
    {
      column: Column.NAME,
      key: ColumnKeys.NAME,
      columnName: translateFn('Name'),
      type: ColumnType.STRING,
      editingDisabled: true,
      removable: false,
    },
    {
      column: Column.IP,
      key: ColumnKeys.IP,
      columnName: translateFn('IP address'),
      type: ColumnType.STRING,
      editingDisabled: true,
      removable: false,
    },
    {
      column: Column.CUSTOM_HOST_NAME,
      key: ColumnKeys.CUSTOM_HOST_NAME,
      columnName: translateFn('Custom name/IP'),
      type: ColumnType.STRING,
      removable: false,
    },
  ];
}
